import React from "react";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import styles from "./index.module.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const ConfirmationforTransferToOnfleet = ({ open, setOpen, changeToOnFleet }) => {

    const closeModel = () => {
        setOpen(false)
    }
    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={closeModel}
                classes={{
                    paper: styles.confirmmodalDialog,
                }}
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description">
                <DialogContent className={`${styles.modalContent} `}>
                    <div style={{ color: "#f30000", fontSize: "17px" }}>
                        <p><b>Cancelled Burq Order:</b></p>

                        French Florist may not receive a refund from Burq if a driver was already assigned. Please confirm the order status
                        in both Burq and Onfleet to ensure everything processed successfully. The client will not notice this change.
                      </div>
                    <div>
                        <a data-dismiss="modal"
                            onClick={changeToOnFleet}
                            className="btn gray-btn d-inline-block mb-3 mr-2 mt-2"
                            style={{ color: "white" }}>
                            Proceed
                        </a>
                        <a data-dismiss="modal"
                            onClick={closeModel}
                            className={`secondary-btn d-inline-block mt-4 mb-3 mr-2  cursor-pointer`}
                            style={{ color: "white" }}>
                            Cancel
                        </a>
                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default ConfirmationforTransferToOnfleet